import React from 'react';

import { Content } from '../../components/shared/Content';
import useTranslation from '../../hooks/useTranslation';

const EFakturaHistoryHeader: React.FC = () => {
    const translated = useTranslation();
    return (
        <Content>
            <h2>{translated.eFakturaHistory.title}</h2>
            <p>{translated.eFakturaHistory.description}</p>
        </Content>
    );
};

export default EFakturaHistoryHeader;
